import {Colors} from 'appearance'
import RemoveIcon from '@mui/icons-material/Remove'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import {
    IconButton,
    ListItemIcon,
    MenuItem,
    styled,
    Typography,
} from '@mui/material'

const NotificationRemoveIcon = ({onClick}) => {
    return (
        <ListItemIcon>
            <NotificationRemoveButton size="small" onClick={onClick}>
                <RemoveIcon />
            </NotificationRemoveButton>
        </ListItemIcon>
    )
}

const Notification = ({notification, onClick}) => {
    return (
        <NotificationContainer key={notification.id} onClick={onClick}>
            <NotificationRemoveIcon />
            <NotificationSender>{notification.sender}</NotificationSender>
            <NotificationText noWrap>{notification.text}</NotificationText>
            <IconButton>
                <KeyboardArrowLeftIcon />
            </IconButton>
        </NotificationContainer>
    )
}

export default Notification

const NotificationContainer = styled(MenuItem)`
    display: flex;
    justify-content: space-between;
    gap: 15px;
    padding: 4px 0;
    &:hover {
        background: transparent;
    }
`

const NotificationSender = styled(Typography)`
    font-size: 16px;
    font-weight: 400;
`

const NotificationText = styled(Typography)`
    color: ${Colors.SUCCESS_TEXT};
    font-size: 16px;
    font-weight: 400;
`
const NotificationRemoveButton = styled(IconButton)`
    background: ${Colors.ICONS_BACKGROUND};
`
